/**
 * Shown on destinations opened from Soren (from=soren / sourceContext=soren).
 * Closing returns to dashboard and reopens the Soren sheet.
 */
import { useNavigate, useSearchParams } from 'react-router-dom'
import { isFromSoren, requestSorenReopen } from './sorenSession'
import './sorenHome.css'

export default function BackToSorenBanner() {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  if (!isFromSoren(searchParams)) return null

  function clearAndReturn() {
    requestSorenReopen()
    const next = new URLSearchParams(searchParams)
    next.delete('from')
    next.delete('sourceContext')
    setSearchParams(next, { replace: true })
    navigate('/dashboard')
  }

  return (
    <div className="soren-back-bar" data-testid="back-to-soren">
      <button type="button" className="soren-back-btn" onClick={clearAndReturn}>
        ← Back to Soren
      </button>
      <span className="soren-back-hint">Opened from Soren</span>
    </div>
  )
}
